export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/provider-transport.cbf10c21-860475.svg";